module.exports = "<div style=\"height: 25%\">\r\n    <div id=\"debugWatch\" style=\"display: none; height: 100%\">\r\n        <table id=\"debugWatchTable\">\r\n        </table>\r\n    </div>\r\n\r\n    <div class=\"history\" readonly #scrollMe id=\"history\" style=\"word-break: break-all;\">\r\n        <p *ngFor=\"let cmd of cmds\" [style.color]=\"cmd.color\">\r\n            {{cmd.text}}\r\n        </p>\r\n    </div>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/history.component.html
// module id = ./src/app/components/history.component.html
// module chunks = main